import React from "react";

export const PageHeader = ({ title, subtitle, right }) => (
  <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-5 mb-10 pr-rise">
    <div className="min-w-0">
      <h1 data-testid="page-title" className="font-display text-[#2A1C15] text-4xl sm:text-5xl leading-[1.05] break-words">
        {title}
      </h1>
      {subtitle && (
        <p className="text-[#5E4D40] text-sm md:text-base mt-3 max-w-2xl leading-relaxed">{subtitle}</p>
      )}
    </div>
    {right && <div className="min-w-0 max-w-full">{right}</div>}
  </div>
);

export const SectionTitle = ({ children, right }) => (
  <div className="flex items-center justify-between gap-3 mb-5">
    <h2 className="font-heading text-[#2A1C15] text-base md:text-lg">{children}</h2>
    {right && <div className="text-[#5E4D40] text-sm">{right}</div>}
  </div>
);

export const Card = ({ className = "", children, ...props }) => (
  <div className={`bj-card p-6 min-w-0 ${className}`} {...props}>
    {children}
  </div>
);

const TONE = {
  gold: "text-[#2A1C15]",
  green: "text-[#14281E]",
  amber: "text-[#6E5022]",
  red: "text-[#5C1A24]",
  white: "text-[#2A1C15]",
};

const TONE_HEX = { green: "#14281E", amber: "#6E5022", red: "#5C1A24" };

export const StatCard = ({ label, value, suffix, prefix, note, testid, tone }) => (
  <div
    data-testid={testid}
    className="bj-card p-6 flex flex-col gap-2 min-h-[136px] min-w-0"
    style={TONE_HEX[tone] ? { borderTop: `2px solid ${TONE_HEX[tone]}` } : undefined}
  >
    <div className="bj-label">{label}</div>
    <div className="bj-metric" style={TONE_HEX[tone] ? { color: TONE_HEX[tone] } : undefined}>
      {prefix}
      {typeof value === "number" ? value.toLocaleString() : value}
      {suffix}
    </div>
    {note && <div className="text-[12px] text-[#5E4D40]">{note}</div>}
  </div>
);

const GOOD = "text-[#14281E]";
const WAIT = "text-[#6E5022]";
const BAD = "text-[#5C1A24]";
const NEUTRAL = "text-[#5E4D40]";

const STATUS_STYLES = {
  Active: GOOD, Completed: GOOD, Paid: GOOD, Approved: GOOD, Awarded: GOOD, Filed: GOOD, Reporting: GOOD,
  Onboarding: WAIT, Pending: WAIT, Submitted: WAIT, "In Progress": WAIT, "Under Review": WAIT, "In Review": WAIT,
  Overdue: BAD, Denied: BAD, Cancelled: BAD,
  Paused: NEUTRAL, Drafting: NEUTRAL, "Not Started": NEUTRAL, Idle: NEUTRAL,
};

export const StatusPill = ({ status }) => (
  <span className={`pr-tag ${STATUS_STYLES[status] || NEUTRAL}`}>{status}</span>
);

export const Money = ({ value, tone, className = "" }) => (
  <span className={`bj-tnum ${tone ? TONE[tone] : ""} ${className}`}>
    ${Number(value).toLocaleString()}
  </span>
);
